import fadeDirection from "./fade-direction-slight-center"
export default function (opts = {}) {
  return fadeDirection.call(this, "y", -1, opts, opts.offset)
}
